<template>
  <v-footer
    dark
    color="#139393"
    padless
  >
    <v-card
      class="flex"
      flat
      tile
      color="#139393"
    >
      <v-card-text class="py-2 white--text text-center">
      Copyright ©{{ new Date().getFullYear() }} — <strong>Tapes To Digital.</strong> All Rights Reserved.
      </v-card-text>
    </v-card>
  </v-footer>
</template>


<script>
  import { mapState } from 'vuex'
  export default {
    components:{
      //
    },
    computed: mapState({
      //
    }),
    props:[
      //
    ],
    data: () => ({
    }),
    created() {
      //
    },
    mounted() {
    },
    methods: {
      //
    }
  }
</script>